var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo, useRef, useState } from "react";
import { usePublicChatContext } from "./publicChatProvider";
export function useTranscript({ start, end, limit, abortSignal, getFormatter, }) {
    const { fetchMessages } = usePublicChatContext();
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState(null);
    const formatterRef = useRef();
    if (!formatterRef.current) {
        formatterRef.current = getFormatter();
    }
    const formatter = formatterRef.current;
    const load = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        try {
            const fetchedMessages = yield fetchMessages({
                limit,
                type: "range",
                loadActionsStrategy: "none",
                // Recall that when fetching from PubNub, "start" is chronologically
                // later than "end". Here, we invert this for the caller's benefit.
                // They're requesting a range of messages, and intuitively the start
                // of the range would be chronologically earlier than the end, I think.
                start: end,
                end: start,
                abortSignal,
            });
            setMessages(fetchedMessages.reduce((arr, { type, data }) => {
                if (type === "chat") {
                    arr.push(data);
                }
                return arr;
            }, []));
            return fetchedMessages;
        }
        finally {
            setLoading(false);
        }
    }), [fetchMessages, start, end, limit, abortSignal]);
    const transcript = useMemo(() => {
        if (!messages) {
            return null;
        }
        return formatter.format(messages);
    }, [messages]);
    return {
        messages,
        transcript,
        loading,
        load,
    };
}
